import React from 'react';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <div className="header__inner">
        <a href="/" className="header__logo">
          <span className="logo-text">ND<span className="logo-accent">TV</span></span>
        </a>
      </div>
    </header>
  );
}

export default Header;
